import { render, staticRenderFns } from "./IntegrationFormSlack.vue?vue&type=template&id=195b12da&scoped=true"
import script from "./IntegrationFormSlack.vue?vue&type=script&lang=js"
export * from "./IntegrationFormSlack.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "195b12da",
  null
  
)

export default component.exports